import { apiConfig, client } from '@/api';
import { TelemetryApi } from '@/api/generated/MNT/apis/telemetry-api';
import { config } from '@/config';

export const telemetryApi = new TelemetryApi(apiConfig, config.API_URL, client);
